<!-- =========================================================================================
    File Name: Error404.vue
    Description: 404 Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<vx-card class="align-center systemSettings">
		<h2>{{ $t("globalSettings") }}</h2>

		<vs-tabs v-model="activeTabItem" v-if="categories.length > 0" position="left">
			<vs-tab
				v-for="(tab, tabIndex) in categories"
				:key="tab"
				:label="$t(`systemSettingsGroup.${tab}`)"
			>
				<div class="tab-content">
					<SettingsForm :settings="settings[tab]" :category="tab" @update="loadData"/>
				</div>
			</vs-tab>
		</vs-tabs>

	</vx-card>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import SettingsForm from "./SettingsForm.vue";

export default {
	name: "Settings",
	components: { SettingsForm },
	mixins: [databaseManager, notifier],
	data() {
		return {
			settings: {},
			activeTabItem: 0,
		};
	},
	computed: {
		categories() {
			return Object.keys(this.settings);
		}
	},

	async mounted() {
		try {
			this.settings = await this.loadData();
		} catch (e) {
			console.log(e);
		}
	},

	methods: {
		async loadData(id) {
			try {
				return await this.dbGetSystemSettings();
			} catch (e) {
				this.notifyError(e.message);
			}
		}
	}
};
</script>

<style>
.systemSettings .vs-tabs--btn {
	min-width: 150px;
}
.systemSettings .vs-tab-head {
	justify-content: right;
}
.systemSettings .tab-content {
	padding-left: 30px;
}
</style>
